module.exports = __webpack_public_path__ + "img/user-interface.673b6143.svg";